export function getCurrencyDisplay(stringAmount = '') {
  const amount = parseFloat(stringAmount.replace(/[^0-9.]/g, ''));

  return !isNaN(amount) ? `$${amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}` : '';
}
